const getFrontBuildVersion = () => process.env.REACT_APP_DEPLOY_VERSION || 'Not specified';

export default getFrontBuildVersion;
